import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppService} from 'app/services/app.service';
import {MainModelService} from './mainModel.service';
import {ApiResponse} from 'app/entities/apiResponse.entity';
import {environment} from 'environments/environment';
import {Pagination} from 'app/entities/pagination.entity';

@Injectable({
  providedIn: 'root'
})
export class SakuraModelService extends MainModelService {

  public requestPrefix = environment.requestPrefix;
  public requestParam = environment.requestParam;

  constructor(
    http: HttpClient,
    appService: AppService
  ) {
    super(http, appService);
  }

  async get(
    getData: any,
    request: string,
    callback: (answer: ApiResponse) => void,
    loading = false,
    message: boolean | string = false
  ) {
    getData = this.addRequestToGet(getData, request);
    await this.getRequest(getData, callback, null, loading, message);
  }

  async post(
    postData: any,
    getData: any,
    request: string,
    callback: (answer: ApiResponse) => void,
    loading: boolean = true
  ) {
    getData = this.addRequestToGet(getData, request);
    await this.postRequest(postData, getData, callback, null, loading);
  }

  async delete(
    postData: any,
    getData: any,
    request: string,
    callback: (answer: ApiResponse) => void,
    loading: boolean = true
  ) {
    getData = this.addRequestToGet(getData, request);
    await this.deleteRequest(postData, getData, callback, null, loading);
  }

  protected async handleError(data: any, callback: (answer: ApiResponse) => void, message) {

    let m = data?.error?.message;
    if (data?.error?.errors?.value_date) {
      m = data.error?.errors?.value_date?.[0];
    }
    if (data?.error?.errors?.value_date_period) {
      m = data.error?.errors?.value_date_period?.[0];
    }
    if (data?.error?.errors?.value_json) {
      m = data.error?.errors?.value_json?.[0];
    }
    if (data?.error?.errors?.value_number) {
      m = data.error?.errors?.value_number?.[0];
    }
    if (data?.error?.errors?.value_string) {
      m = data.error?.errors?.value_string?.[0];
    }
    if (!data.status) {
      m = data.message;
    }

    const response: ApiResponse = new ApiResponse({status: false, message: m});

    if (message) {
      await this.appService.showToast(
        response.message ? response.message : (typeof message === 'string' ? message : 'Ошибка'),
        'danger'
      );
    }

    super.handleError(response, callback);
  }

  protected async handleSuccess(httpResponse: any, callback: (answer: ApiResponse) => void) {
    const data = httpResponse.body;
    const response: ApiResponse = typeof data.status !== 'undefined' ? new ApiResponse(data) : this.packAnswerToApiResponse(data, httpResponse);

    this.addPaginationObject(response, httpResponse);

    super.handleSuccess(response, callback);
  }

  protected addPaginationObject(response: ApiResponse, httpResponse) {
    if (httpResponse?.headers?.get('x-pagination-page-count')) {
      response.pagination = new Pagination(
        httpResponse?.headers?.get('x-pagination-current-page'),
        httpResponse?.headers?.get('x-pagination-per-page'),
        httpResponse?.headers?.get('x-pagination-page-count'),
        httpResponse?.headers?.get('x-pagination-total-count')
      );
    }
  }

  protected packAnswerToApiResponse(data, httpResponse): ApiResponse {
    const response: ApiResponse = new ApiResponse();

    if (typeof data === 'string') {
      data = data === 'true' || data === '1';
    }

    if (typeof data === 'boolean') {
      response.status = data;
      response.message = 'Пользователь не найден';
    } else {
      if (typeof data.success !== 'undefined') {
        response.status = data.success;
        delete data.success;
      }

      if (typeof data.message !== 'undefined') {
        response.message = data.message;
        delete data.message;
      }

      response.result = data;
    }

    return response;
  }

  private addRequestToGet(data = {}, request: string) {
    return {...{[this.requestParam]: `${this.requestPrefix}${request}`}, ...data};
  }
}
